/* eslint-disable no-underscore-dangle */
import {
  COMMENT_VOTES,
  COMMENT_VOTES_BUTTON_ACTIVE,
  COMMENT_VOTES_BUTTON_DOWNVOTE,
  COMMENT_VOTES_BUTTON_UPVOTE,
  COMMENT_VOTES_DOWNVOTES,
  COMMENT_VOTES_FORM_DOWNVOTE,
  COMMENT_VOTES_FORM_UPVOTE,
  COMMENT_VOTES_UPVOTES,
} from "../constants"

/** @typedef {import('../models/comment-votes-entity').default} CommentVotesEntity */

export default class CommentVotesElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof CommentVotesElement
   */
  static fromHtmlElement(htmlElement) {
    return new CommentVotesElement({
      root: htmlElement.querySelector(COMMENT_VOTES),
      upvoteForm: htmlElement.querySelector(COMMENT_VOTES_FORM_UPVOTE),
      downvoteForm: htmlElement.querySelector(COMMENT_VOTES_FORM_DOWNVOTE),
      upvoteButton: htmlElement.querySelector(COMMENT_VOTES_BUTTON_UPVOTE),
      downvoteButton: htmlElement.querySelector(COMMENT_VOTES_BUTTON_DOWNVOTE),
      upvotesElement: htmlElement.querySelector(COMMENT_VOTES_UPVOTES),
      downvotesElement: htmlElement.querySelector(COMMENT_VOTES_DOWNVOTES),
    })
  }

  /**
   * Creates an instance of CommentVotesElement.
   * @param {Object} settings
   * @param {HTMLElement} settings.root
   * @param {HTMLFormElement} settings.upvoteForm
   * @param {HTMLFormElement} settings.downvoteForm
   * @param {HTMLButtonElement} settings.upvoteButton
   * @param {HTMLButtonElement} settings.downvoteButton
   * @param {HTMLElement} settings.upvotesElement
   * @param {HTMLElement} settings.downvotesElement
   * @memberof CommentVotesElement
   */
  constructor({
    root,
    upvoteForm,
    downvoteForm,
    upvoteButton,
    downvoteButton,
    upvotesElement,
    downvotesElement,
  }) {
    this.root = root
    this.upvoteForm = upvoteForm
    this.downvoteForm = downvoteForm
    this.upvoteButton = upvoteButton
    this.downvoteButton = downvoteButton
    this.upvotesElement = upvotesElement
    this.downvotesElement = downvotesElement

    this._upvoteCallbackList = []
    this.upvoteForm.addEventListener("submit", (event) => {
      event.preventDefault()
      this._upvoteCallbackList.forEach((cb) => cb())
    })

    this._downvoteCallbackList = []
    this.downvoteForm.addEventListener("submit", (event) => {
      event.preventDefault()
      this._downvoteCallbackList.forEach((cb) => cb())
    })
  }

  /**
   * @param {function() : void} callback
   * @memberof CommentVotesElement
   */
  onUpvote(callback) {
    this._upvoteCallbackList.push(callback)
  }

  /**
   * @param {function() : void} callback
   * @memberof CommentVotesElement
   */
  onDownvote(callback) {
    this._downvoteCallbackList.push(callback)
  }

  /**
   * @param {CommentVotesEntity} commentVotes
   * @param {Number} commentId
   * @memberof CommentVotesElement
   */
  apply(commentVotes, commentId) {
    this.upvoteForm.action = this.upvoteForm.action.replace(/comment_id|\d+/, commentId)
    this.downvoteForm.action = this.upvoteForm.action.replace(/comment_id|\d+/, commentId)

    this.upvoteButton.classList.toggle(COMMENT_VOTES_BUTTON_ACTIVE, commentVotes.isUpvotedByUser)
    this.downvoteButton.classList.toggle(
      COMMENT_VOTES_BUTTON_ACTIVE,
      commentVotes.isDownvotedByUser,
    )

    this.upvotesElement.textContent = commentVotes.upvotes
    this.downvotesElement.textContent = commentVotes.downvotes
  }
}
